const Services = () => {
  const services = [
    {
      title: "Website Creation",
      description: "We build modern, branded websites tailored to your needs.",
      features: [
        "Responsive design",
        "SEO optimization",
        "Up to 5 pages",
        "Custom branding",
        "1 year of hosting",
      ],
      price: "£50/month, £500/annually",
    },
    {
      title: "Cloud Solutions",
      description: "Secure and scalable cloud storage solutions.",
      features: [
        "500GB-1TB storage",
        "Data encryption",
        "24/7 support",
        "Scalable infrastructure",
        "Custom configurations",
      ],
      price: "£80/month, £800/annually",
    },
    {
      title: "Custom Business Guides",
      description: "Empower your team with tailored step-by-step guides designed to streamline workflows and enhance productivity.",
      features: [
        "Custom workflows created to fit your business processes.",
        "Step-by-step instructions with visual aids for clarity.",
        "Easily shareable and accessible guides for your team.",
        "Automated updates to keep processes current.",
        "Optimized for training, onboarding, and process standardisation."
      ],
      price: "£150/project, £1200 for 10 guides"
    },
    {
      title: "SEO Optimisation",
      description: "Boost your online visibility with SEO-focused solutions designed to drive traffic and improve rankings.",
      features: [
        "Keyword research to target the right audience.",
        "Optimized site structure and meta tags.",
        "Improved speed, mobile responsiveness, and crawlability.",
        "SEO-friendly content creation.",
        "Regular performance reports and analytics."
      ],
      price: "£150/month, £1500/annually"
    },
    {
      title: "Small-Scale Applications",
      description: "Lightweight applications tailored for your business.",
      features: [
        "Custom-built application",
        "User-friendly UI/UX",
        "Database integration",
        "Scalable and lightweight",
        "Dedicated support",
      ],
      price: "£250/month, £2200/annually",
    },
  ];

  return (
    <section className="container mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-center mb-10 text-brandcolour">
        Our Services
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service, index) => (
          <div
            key={index}
            className="p-6 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg"
          >
            <h2 className="text-xl font-semibold text-center text-brandcolour">
              {service.title}
            </h2>
            <p className="text-sm text-gray-700 dark:text-gray-300 text-center mb-4">
              {service.description}
            </p>
            <ul className="list-disc list-inside text-sm mb-4 text-gray-700 dark:text-gray-300">
              {service.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
            <p className="text-center text-lg font-bold text-brandcolour">
              {service.price}
            </p>
          </div>
        ))}
      </div>
      {/* Disclaimer Section */}
      <div className="mt-10 text-center">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          <strong>Disclaimer:</strong> All prices are estimates and subject to
          change based on the size and complexity of your project. Design and
          development time may also impact final pricing.
        </p>
      </div>
    </section>
  );
};

export default Services;
